// import { Settings, BookOpen } from 'lucide-react';

interface Hero21Props {
  title?: string;
}

export const Hero21 = ({
  title = 'The perfect analytics tool for your online business'
}: Hero21Props) => {
  return (
    <section
      id="hero-21"
      className="hero-section pt-[170px] lg:max-xl:pt-[150px] md:max-lg:pt-[80px] xsm:max-sm:overflow-visible xsm:max-sm:!mb-[50px] md:max-lg:!mt-[80px] bg-black"
    >
      <div className="container !text-center">
        {/* HERO TEXT */}
        <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)] justify-center">
          <div className="w-full flex-[0_0_auto] px-[calc(0.5*_1.5rem)] max-w-full">
            <div className="hero-21-txt wow fadeInUp mb--60 !mb-[60px] lg:max-xl:!mb-[50px] md:max-lg:!mb-[40px] xsm:max-sm:!mb-[50px]">
              <div
                className="case-badge"
                style={{
                  height: '36px',
                  display: 'flex',
                  alignItems: 'center',
                  width: 'fit-content',
                  background: 'transparent',
                  borderWidth: '1px',
                  borderStyle: 'solid',
                  borderColor: 'white',
                  borderRadius: '999px',
                  padding: '8px 16px',
                  margin: '0 auto',
                  marginBottom: '32px'
                }}
              >
                <span
                  style={{
                    color: 'white'
                  }}
                >
                  ✨ Case Study Success Story
                </span>
              </div>
              {/* Title */}
              <h2
                data-nosnippet
                className="s-56 w--700 xl:!text-[3.5rem] md:max-lg:!text-[2.94117rem] lg:max-xl:!text-[3.25rem] sm:max-md:!text-[2.375rem] xsm:max-sm:!text-[2.0625rem] !text-white !font-bold leading-[1.25] font-Jakarta sm:max-md:!leading-[1.35] xsm:max-sm:!leading-[1.35] xl:!mb-[35px] lg:max-xl:!mb-[25px] md:max-lg:!mb-[20px] md:max-lg:px-[3%] md:max-lg:py-0 sm:max-md:!mb-[20px] xsm:max-sm:!mb-[18px]"
              >
                {title}
              </h2>
              {/* Stats Section */}
              <div className="flex flex-wrap justify-center gap-8 xl:gap-12 lg:max-xl:gap-10 md:max-lg:gap-8 sm:max-md:gap-6 xsm:max-sm:gap-4 xl:!mt-[50px] lg:max-xl:!mt-[40px] md:max-lg:!mt-[35px] sm:max-md:!mt-[30px] xsm:max-sm:!mt-[25px]">
                <div className="flex flex-col items-center">
                  <div className="text-white font-bold xl:!text-[3rem] lg:max-xl:!text-[2.5rem] md:max-lg:!text-[2.25rem] sm:max-md:!text-[2rem] xsm:max-sm:!text-[1.75rem] font-Jakarta leading-tight">
                    $35
                  </div>
                  <div className="text-white/80 text-sm xl:!text-base md:max-lg:!text-sm xsm:max-sm:!text-xs mt-2 font-Jakarta">
                    Cost-per-Lead
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <div className="text-white font-bold xl:!text-[3rem] lg:max-xl:!text-[2.5rem] md:max-lg:!text-[2.25rem] sm:max-md:!text-[2rem] xsm:max-sm:!text-[1.75rem] font-Jakarta leading-tight">
                    $118
                  </div>
                  <div className="text-white/80 text-sm xl:!text-base md:max-lg:!text-sm xsm:max-sm:!text-xs mt-2 font-Jakarta">
                    Cost-per-Listing
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <div className="text-white font-bold xl:!text-[3rem] lg:max-xl:!text-[2.5rem] md:max-lg:!text-[2.25rem] sm:max-md:!text-[2rem] xsm:max-sm:!text-[1.75rem] font-Jakarta leading-tight">
                    8x
                  </div>
                  <div className="text-white/80 text-sm xl:!text-base md:max-lg:!text-sm xsm:max-sm:!text-xs mt-2 font-Jakarta">
                    ROI
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* END HERO TEXT */}

        {/* ADD CASE STUDY METRICS HERE */}

        {/* HERO IMAGE */}
        {/* <div className="hero-21-wrapper rounded-[34px] overflow-hidden sm:max-md:rounded-[12px] xsm:max-sm:overflow-visible xsm:max-sm:mr-[-15px] xsm:max-sm:ml-[-15px] xsm:max-sm:my-0 xsm:max-sm:rounded-[0_0]">
          <div
            className="hero-overlay bg--fixed bg-[url(/images/hero-21.jpg)] pt-[90px] !pb-0 px-[70px] lg:max-xl:pt-[80px] lg:max-xl:!pb-0 lg:max-xl:px-[60px] md:max-lg:pt-[65px] md:max-lg:!pb-0 md:max-lg:px-[45px] sm:max-md:pt-[55px] sm:max-md:!pb-0 sm:max-md:px-[35px] xsm:max-sm:relative xsm:max-sm:pt-[60px] xsm:max-sm:!pb-0 xsm:max-sm:px-[25px] bg-scroll sm:max-md:w-auto xsm:max-sm:w-auto w-full bg-no-repeat bg-[center_center] bg-cover"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          >
            <div className="flex flex-wrap mx-[calc(-0.5*_1.5rem)]">
              <div className="flex-[0_0_auto] w-full max-w-full px-[calc(0.5*_1.5rem)]">
                <div className="hero-21-img video-preview wow fadeInUp relative mb-[-25%] lg:max-xl:!mb-[-25%] md:max-lg:!mb-[-24%] sm:max-md:!mb-[-18%] xsm:max-sm:!mb-[-50px]">
                  <a
                    className="video-popup1"
                    href="https://www.youtube.com/embed/SZEflIVnhH8"
                  >
                    <div className="video-btn video-btn-xl top-[calc(50%_-_80px)] md:max-lg:top-[calc(50%_-_50px)] sm:max-md:top-[calc(50%_-_30px)] xsm:max-sm:top-[calc(50%_-_2px)] !w-[6.25rem] !h-[6.25rem] mt-[-3.125rem] ml-[-3.125rem] md:max-lg:w-28 md:max-lg:!h-28 md:max-lg:!mt-[-3.5rem] md:max-lg:ml-[-3.5rem] !absolute inline-block !text-center !text-white rounded-[100%] left-2/4 before:content-[''] before:absolute before:left-[-5px] before:right-[-5px] before:top-[-5px] before:bottom-[-5px] before:opacity-0 before:transition-all before:duration-[400ms] before:ease-[ease-in-out] before:rounded-[50%] before:bg-[rgba(255,255,255,0.2)] group hover:before:opacity-75 hover:before:left-[-1.5rem] hover:before:right-[-1.5rem] hover:before:top-[-1.5rem] hover:before:bottom-[-1.5rem] bg--theme">
                      <div className="video-block-wrapper transition-all duration-[400ms] ease-[ease-in-out] group-hover:scale-95">
                        <span className="flaticon-play-button"></span>
                      </div>
                    </div>
                  </a>
                  <img
                    className="img-fluid inline-block"
                    src="/images/tablet-01.png"
                    alt="video-preview"
                  />
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* End hero-21-wrapper */}
      </div>
      {/* End container */}
    </section>
  );
};
